const ComboDetailInfo = () => {
  return (
    <div>
      <p className="ms-4 text-muted fst-italic">
        Thông tin chi tiết về sản phẩm trong combo vui lòng tra cứu dưới đây
      </p>
      <div>
        <table className="text-center m-auto">
          <thead>
            <tr>
              <th>Sản phẩm</th>
              <th>Khăn giấy Mễ Mễ</th>
              <th>Khăn ướt Mễ Mễ</th>
              <th>Tã/bỉm Mễ Mễ</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Số tờ/ lớp</td>
              <td>300 tờ, 4 lớp</td>
              <td>100 tờ</td>
              <td>5 lớp</td>
            </tr>

            <tr>
              <td>Kích thước (mm, size)</td>
              <td>120 x 90 x 50 (D x R x C)</td>
              <td>150 x 100 x 70 (D x R x C)</td>
              <td>Tùy chọn (tham khảo bảng chọn size bên dưới).</td>
            </tr>

            <tr>
              <td>Thành phần</td>
              <td>
                100% bột gỗ giấy nguyên sinh được sản xuất hoàn toàn từ gỗ tự
                nhiên.
              </td>
              <td>
                Vải không dệt cotton 100% từ sợi tự nhiên, nước tinh khiết được
                lọc qua công nghệ thẩm thấu ngược RO tiên tiến nhất, an toàn cho
                em bé và cả những làn da nhạy cảm nhất.
              </td>
              <td>
                + Vải không dệt tổng hợp, hạt SAP, bông cao cấp nhập khẩu từ Mỹ.
                <br /> + Dưỡng chất Vitamin E, axit yếu từ thiên nhiên.
              </td>
            </tr>

            <tr>
              <td>Quy cách đóng gói</td>
              <td colSpan={3}>
                - 1 gói khăn giấy gồm 300 tờ, 4 lớp.
                <br /> - 1 gói khăn ướt gồm 100 tờ
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div>
        <p className="ms-4 mt-4 text-muted fst-italic">
          Bảng chọn size tã/bỉm Mễ Mễ
        </p>
        <table className="text-center m-auto">
          <thead>
            <tr>
              <th>Sản phẩm</th>
              <th colSpan={2}>Tã dán Mễ Mễ</th>
              <th colSpan={5}>Tã quần Mễ Mễ</th>
            </tr>
          </thead>

          <tbody>
            <tr>
              <td>Kích cỡ (size)</td>
              <td style={{ width: "110px" }}>S</td>
              <td style={{ width: "110px" }}>M</td>
              <td style={{ width: "110px" }}>M</td>
              <td style={{ width: "110px" }}>L</td>
              <td style={{ width: "110px" }}>XL</td>
              <td style={{ width: "110px" }}>XXL</td>
              <td style={{ width: "110px" }}>XXXL</td>
            </tr>

            <tr>
              <td>Số miếng</td>
              <td>68</td>
              <td>64</td>
              <td>62</td>
              <td>58</td>
              <td>54</td>
              <td>50</td>
              <td>46</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ComboDetailInfo;
